import { getVerse } from "../utils/fetch.js";
import { ApiData } from "../schema/apiData.js";
import { ChildCheckStats, Item, Items, ParentItem } from "../schema/item.js";
import { calcCheckStats } from "./tsx/cell/check.jsx";

export const fetchVerseData = async (): Promise<ParentItem[]> => {
  const rawData = (await getVerse()) as any[];
  const datum = ApiData.initByArray(rawData);
  if (ApiData.hasErrors(datum)) throw "Response is not valid.";
  return parseData(datum);
};

const parseData = (datum: ApiData[]): ParentItem[] => {
  const result: ParentItem[] = [];
  const nameMap = new Map<string, ParentItem>();
  let [childIndex, parentIndex] = [0, 0];
  datum.forEach((data) => {
    const item = data.convertToItem();
    let parent: ParentItem;

    if (nameMap.has(data.name)) {
      parent = nameMap.get(data.name) as ParentItem;
    } else {
      parent = {
        id: `parent-${parentIndex++}`,
        name: item.name,
        childCheckState: { owned: 0, total: 0, comp: false },
        sec: item.sec,
        star: item.star,
        brand: item.brand,
        itemID: "",
        qr: "",
        children: [],
        element: document.createElement("tr"),
        rowState: {
          open: false,
          selected: false,
        },
      };
      nameMap.set(data.name, parent);
      result.push(parent);
    }

    item.id = `child-${childIndex++}`;
    item.itemID = data.id;
    item.parentID = parent.id;
    item.rowState = { selected: false };
    parent.children.push(item);
  });
  result.forEach((item) => {
    item.childCheckState = calcCheckStats(item);
  });
  return result;
};
